module.exports = function() {
  return new Worker(__webpack_public_path__ + "b2e291aa2f9c71642497.worker.js");
};